import { render, staticRenderFns } from "./CompanyPreview.vue?vue&type=template&id=187908b9"
import script from "./CompanyPreview.vue?vue&type=script&lang=js"
export * from "./CompanyPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports